/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router'

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as publicPublicImport } from './routes/(public)/_public'
import { Route as authRegisterImport } from './routes/(auth)/register'
import { Route as authLoginImport } from './routes/(auth)/login'
import { Route as appDashboardImport } from './routes/(app)/dashboard'
import { Route as publicPublicIndexImport } from './routes/(public)/_public/index'
import { Route as appDashboardIndexImport } from './routes/(app)/dashboard/index'
import { Route as publicPublicFeaturesImport } from './routes/(public)/_public/features'
import { Route as publicPublicDocsImport } from './routes/(public)/_public/docs'
import { Route as appDashboardSettingsImport } from './routes/(app)/dashboard/settings'
import { Route as appDashboardRestaurantsImport } from './routes/(app)/dashboard/restaurants'
import { Route as appDashboardSettingsIndexImport } from './routes/(app)/dashboard/settings/index'
import { Route as appDashboardListsIndexImport } from './routes/(app)/dashboard/lists/index'
import { Route as appDashboardFeaturedIndexImport } from './routes/(app)/dashboard/featured/index'
import { Route as publicPublicListsTokenImport } from './routes/(public)/_public/lists/$token'
import { Route as appDashboardSettingsUserProfileImport } from './routes/(app)/dashboard/settings/user-profile'
import { Route as appDashboardSettingsChangePasswordImport } from './routes/(app)/dashboard/settings/change-password'
import { Route as appDashboardListsDetailListIdImport } from './routes/(app)/dashboard/lists/detail/$listId'

// Create Virtual Routes

const publicImport = createFileRoute('/(public)')()

// Create/Update Routes

const publicRoute = publicImport.update({
  id: '/(public)',
  getParentRoute: () => rootRoute,
} as any)

const publicPublicRoute = publicPublicImport.update({
  id: '/_public',
  getParentRoute: () => publicRoute,
} as any)

const authRegisterRoute = authRegisterImport.update({
  id: '/(auth)/register',
  path: '/register',
  getParentRoute: () => rootRoute,
} as any)

const authLoginRoute = authLoginImport.update({
  id: '/(auth)/login',
  path: '/login',
  getParentRoute: () => rootRoute,
} as any)

const appDashboardRoute = appDashboardImport.update({
  id: '/(app)/dashboard',
  path: '/dashboard',
  getParentRoute: () => rootRoute,
} as any)

const publicPublicIndexRoute = publicPublicIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => publicPublicRoute,
} as any)

const appDashboardIndexRoute = appDashboardIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => appDashboardRoute,
} as any)

const publicPublicFeaturesRoute = publicPublicFeaturesImport.update({
  id: '/features',
  path: '/features',
  getParentRoute: () => publicPublicRoute,
} as any)

const publicPublicDocsRoute = publicPublicDocsImport.update({
  id: '/docs',
  path: '/docs',
  getParentRoute: () => publicPublicRoute,
} as any)

const appDashboardSettingsRoute = appDashboardSettingsImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => appDashboardRoute,
} as any)

const appDashboardRestaurantsRoute = appDashboardRestaurantsImport.update({
  id: '/restaurants',
  path: '/restaurants',
  getParentRoute: () => appDashboardRoute,
} as any)

const appDashboardSettingsIndexRoute = appDashboardSettingsIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => appDashboardSettingsRoute,
} as any)

const appDashboardListsIndexRoute = appDashboardListsIndexImport.update({
  id: '/lists/',
  path: '/lists/',
  getParentRoute: () => appDashboardRoute,
} as any)

const appDashboardFeaturedIndexRoute = appDashboardFeaturedIndexImport.update({
  id: '/featured/',
  path: '/featured/',
  getParentRoute: () => appDashboardRoute,
} as any)

const publicPublicListsTokenRoute = publicPublicListsTokenImport.update({
  id: '/lists/$token',
  path: '/lists/$token',
  getParentRoute: () => publicPublicRoute,
} as any)

const appDashboardSettingsUserProfileRoute =
  appDashboardSettingsUserProfileImport.update({
    id: '/user-profile',
    path: '/user-profile',
    getParentRoute: () => appDashboardSettingsRoute,
  } as any)

const appDashboardSettingsChangePasswordRoute =
  appDashboardSettingsChangePasswordImport.update({
    id: '/change-password',
    path: '/change-password',
    getParentRoute: () => appDashboardSettingsRoute,
  } as any)

const appDashboardListsDetailListIdRoute =
  appDashboardListsDetailListIdImport.update({
    id: '/lists/detail/$listId',
    path: '/lists/detail/$listId',
    getParentRoute: () => appDashboardRoute,
  } as any)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/(app)/dashboard': {
      id: '/(app)/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof appDashboardImport
      parentRoute: typeof rootRoute
    }
    '/(auth)/login': {
      id: '/(auth)/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof authLoginImport
      parentRoute: typeof rootRoute
    }
    '/(auth)/register': {
      id: '/(auth)/register'
      path: '/register'
      fullPath: '/register'
      preLoaderRoute: typeof authRegisterImport
      parentRoute: typeof rootRoute
    }
    '/(public)': {
      id: '/(public)'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof publicImport
      parentRoute: typeof rootRoute
    }
    '/(public)/_public': {
      id: '/(public)/_public'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof publicPublicImport
      parentRoute: typeof publicRoute
    }
    '/(app)/dashboard/restaurants': {
      id: '/(app)/dashboard/restaurants'
      path: '/restaurants'
      fullPath: '/dashboard/restaurants'
      preLoaderRoute: typeof appDashboardRestaurantsImport
      parentRoute: typeof appDashboardImport
    }
    '/(app)/dashboard/settings': {
      id: '/(app)/dashboard/settings'
      path: '/settings'
      fullPath: '/dashboard/settings'
      preLoaderRoute: typeof appDashboardSettingsImport
      parentRoute: typeof appDashboardImport
    }
    '/(public)/_public/docs': {
      id: '/(public)/_public/docs'
      path: '/docs'
      fullPath: '/docs'
      preLoaderRoute: typeof publicPublicDocsImport
      parentRoute: typeof publicPublicImport
    }
    '/(public)/_public/features': {
      id: '/(public)/_public/features'
      path: '/features'
      fullPath: '/features'
      preLoaderRoute: typeof publicPublicFeaturesImport
      parentRoute: typeof publicPublicImport
    }
    '/(app)/dashboard/': {
      id: '/(app)/dashboard/'
      path: '/'
      fullPath: '/dashboard/'
      preLoaderRoute: typeof appDashboardIndexImport
      parentRoute: typeof appDashboardImport
    }
    '/(public)/_public/': {
      id: '/(public)/_public/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof publicPublicIndexImport
      parentRoute: typeof publicPublicImport
    }
    '/(app)/dashboard/settings/change-password': {
      id: '/(app)/dashboard/settings/change-password'
      path: '/change-password'
      fullPath: '/dashboard/settings/change-password'
      preLoaderRoute: typeof appDashboardSettingsChangePasswordImport
      parentRoute: typeof appDashboardSettingsImport
    }
    '/(app)/dashboard/settings/user-profile': {
      id: '/(app)/dashboard/settings/user-profile'
      path: '/user-profile'
      fullPath: '/dashboard/settings/user-profile'
      preLoaderRoute: typeof appDashboardSettingsUserProfileImport
      parentRoute: typeof appDashboardSettingsImport
    }
    '/(public)/_public/lists/$token': {
      id: '/(public)/_public/lists/$token'
      path: '/lists/$token'
      fullPath: '/lists/$token'
      preLoaderRoute: typeof publicPublicListsTokenImport
      parentRoute: typeof publicPublicImport
    }
    '/(app)/dashboard/featured/': {
      id: '/(app)/dashboard/featured/'
      path: '/featured'
      fullPath: '/dashboard/featured'
      preLoaderRoute: typeof appDashboardFeaturedIndexImport
      parentRoute: typeof appDashboardImport
    }
    '/(app)/dashboard/lists/': {
      id: '/(app)/dashboard/lists/'
      path: '/lists'
      fullPath: '/dashboard/lists'
      preLoaderRoute: typeof appDashboardListsIndexImport
      parentRoute: typeof appDashboardImport
    }
    '/(app)/dashboard/settings/': {
      id: '/(app)/dashboard/settings/'
      path: '/'
      fullPath: '/dashboard/settings/'
      preLoaderRoute: typeof appDashboardSettingsIndexImport
      parentRoute: typeof appDashboardSettingsImport
    }
    '/(app)/dashboard/lists/detail/$listId': {
      id: '/(app)/dashboard/lists/detail/$listId'
      path: '/lists/detail/$listId'
      fullPath: '/dashboard/lists/detail/$listId'
      preLoaderRoute: typeof appDashboardListsDetailListIdImport
      parentRoute: typeof appDashboardImport
    }
  }
}

// Create and export the route tree

interface appDashboardSettingsRouteChildren {
  appDashboardSettingsChangePasswordRoute: typeof appDashboardSettingsChangePasswordRoute
  appDashboardSettingsUserProfileRoute: typeof appDashboardSettingsUserProfileRoute
  appDashboardSettingsIndexRoute: typeof appDashboardSettingsIndexRoute
}

const appDashboardSettingsRouteChildren: appDashboardSettingsRouteChildren = {
  appDashboardSettingsChangePasswordRoute:
    appDashboardSettingsChangePasswordRoute,
  appDashboardSettingsUserProfileRoute: appDashboardSettingsUserProfileRoute,
  appDashboardSettingsIndexRoute: appDashboardSettingsIndexRoute,
}

const appDashboardSettingsRouteWithChildren =
  appDashboardSettingsRoute._addFileChildren(appDashboardSettingsRouteChildren)

interface appDashboardRouteChildren {
  appDashboardRestaurantsRoute: typeof appDashboardRestaurantsRoute
  appDashboardSettingsRoute: typeof appDashboardSettingsRouteWithChildren
  appDashboardIndexRoute: typeof appDashboardIndexRoute
  appDashboardFeaturedIndexRoute: typeof appDashboardFeaturedIndexRoute
  appDashboardListsIndexRoute: typeof appDashboardListsIndexRoute
  appDashboardListsDetailListIdRoute: typeof appDashboardListsDetailListIdRoute
}

const appDashboardRouteChildren: appDashboardRouteChildren = {
  appDashboardRestaurantsRoute: appDashboardRestaurantsRoute,
  appDashboardSettingsRoute: appDashboardSettingsRouteWithChildren,
  appDashboardIndexRoute: appDashboardIndexRoute,
  appDashboardFeaturedIndexRoute: appDashboardFeaturedIndexRoute,
  appDashboardListsIndexRoute: appDashboardListsIndexRoute,
  appDashboardListsDetailListIdRoute: appDashboardListsDetailListIdRoute,
}

const appDashboardRouteWithChildren = appDashboardRoute._addFileChildren(
  appDashboardRouteChildren,
)

interface publicPublicRouteChildren {
  publicPublicDocsRoute: typeof publicPublicDocsRoute
  publicPublicFeaturesRoute: typeof publicPublicFeaturesRoute
  publicPublicIndexRoute: typeof publicPublicIndexRoute
  publicPublicListsTokenRoute: typeof publicPublicListsTokenRoute
}

const publicPublicRouteChildren: publicPublicRouteChildren = {
  publicPublicDocsRoute: publicPublicDocsRoute,
  publicPublicFeaturesRoute: publicPublicFeaturesRoute,
  publicPublicIndexRoute: publicPublicIndexRoute,
  publicPublicListsTokenRoute: publicPublicListsTokenRoute,
}

const publicPublicRouteWithChildren = publicPublicRoute._addFileChildren(
  publicPublicRouteChildren,
)

interface publicRouteChildren {
  publicPublicRoute: typeof publicPublicRouteWithChildren
}

const publicRouteChildren: publicRouteChildren = {
  publicPublicRoute: publicPublicRouteWithChildren,
}

const publicRouteWithChildren =
  publicRoute._addFileChildren(publicRouteChildren)

export interface FileRoutesByFullPath {
  '/dashboard': typeof appDashboardRouteWithChildren
  '/login': typeof authLoginRoute
  '/register': typeof authRegisterRoute
  '/': typeof publicPublicIndexRoute
  '/dashboard/restaurants': typeof appDashboardRestaurantsRoute
  '/dashboard/settings': typeof appDashboardSettingsRouteWithChildren
  '/docs': typeof publicPublicDocsRoute
  '/features': typeof publicPublicFeaturesRoute
  '/dashboard/': typeof appDashboardIndexRoute
  '/dashboard/settings/change-password': typeof appDashboardSettingsChangePasswordRoute
  '/dashboard/settings/user-profile': typeof appDashboardSettingsUserProfileRoute
  '/lists/$token': typeof publicPublicListsTokenRoute
  '/dashboard/featured': typeof appDashboardFeaturedIndexRoute
  '/dashboard/lists': typeof appDashboardListsIndexRoute
  '/dashboard/settings/': typeof appDashboardSettingsIndexRoute
  '/dashboard/lists/detail/$listId': typeof appDashboardListsDetailListIdRoute
}

export interface FileRoutesByTo {
  '/login': typeof authLoginRoute
  '/register': typeof authRegisterRoute
  '/dashboard/restaurants': typeof appDashboardRestaurantsRoute
  '/docs': typeof publicPublicDocsRoute
  '/features': typeof publicPublicFeaturesRoute
  '/dashboard': typeof appDashboardIndexRoute
  '/': typeof publicPublicIndexRoute
  '/dashboard/settings/change-password': typeof appDashboardSettingsChangePasswordRoute
  '/dashboard/settings/user-profile': typeof appDashboardSettingsUserProfileRoute
  '/lists/$token': typeof publicPublicListsTokenRoute
  '/dashboard/featured': typeof appDashboardFeaturedIndexRoute
  '/dashboard/lists': typeof appDashboardListsIndexRoute
  '/dashboard/settings': typeof appDashboardSettingsIndexRoute
  '/dashboard/lists/detail/$listId': typeof appDashboardListsDetailListIdRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  '/(app)/dashboard': typeof appDashboardRouteWithChildren
  '/(auth)/login': typeof authLoginRoute
  '/(auth)/register': typeof authRegisterRoute
  '/(public)': typeof publicRouteWithChildren
  '/(public)/_public': typeof publicPublicRouteWithChildren
  '/(app)/dashboard/restaurants': typeof appDashboardRestaurantsRoute
  '/(app)/dashboard/settings': typeof appDashboardSettingsRouteWithChildren
  '/(public)/_public/docs': typeof publicPublicDocsRoute
  '/(public)/_public/features': typeof publicPublicFeaturesRoute
  '/(app)/dashboard/': typeof appDashboardIndexRoute
  '/(public)/_public/': typeof publicPublicIndexRoute
  '/(app)/dashboard/settings/change-password': typeof appDashboardSettingsChangePasswordRoute
  '/(app)/dashboard/settings/user-profile': typeof appDashboardSettingsUserProfileRoute
  '/(public)/_public/lists/$token': typeof publicPublicListsTokenRoute
  '/(app)/dashboard/featured/': typeof appDashboardFeaturedIndexRoute
  '/(app)/dashboard/lists/': typeof appDashboardListsIndexRoute
  '/(app)/dashboard/settings/': typeof appDashboardSettingsIndexRoute
  '/(app)/dashboard/lists/detail/$listId': typeof appDashboardListsDetailListIdRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/dashboard'
    | '/login'
    | '/register'
    | '/'
    | '/dashboard/restaurants'
    | '/dashboard/settings'
    | '/docs'
    | '/features'
    | '/dashboard/'
    | '/dashboard/settings/change-password'
    | '/dashboard/settings/user-profile'
    | '/lists/$token'
    | '/dashboard/featured'
    | '/dashboard/lists'
    | '/dashboard/settings/'
    | '/dashboard/lists/detail/$listId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/login'
    | '/register'
    | '/dashboard/restaurants'
    | '/docs'
    | '/features'
    | '/dashboard'
    | '/'
    | '/dashboard/settings/change-password'
    | '/dashboard/settings/user-profile'
    | '/lists/$token'
    | '/dashboard/featured'
    | '/dashboard/lists'
    | '/dashboard/settings'
    | '/dashboard/lists/detail/$listId'
  id:
    | '__root__'
    | '/(app)/dashboard'
    | '/(auth)/login'
    | '/(auth)/register'
    | '/(public)'
    | '/(public)/_public'
    | '/(app)/dashboard/restaurants'
    | '/(app)/dashboard/settings'
    | '/(public)/_public/docs'
    | '/(public)/_public/features'
    | '/(app)/dashboard/'
    | '/(public)/_public/'
    | '/(app)/dashboard/settings/change-password'
    | '/(app)/dashboard/settings/user-profile'
    | '/(public)/_public/lists/$token'
    | '/(app)/dashboard/featured/'
    | '/(app)/dashboard/lists/'
    | '/(app)/dashboard/settings/'
    | '/(app)/dashboard/lists/detail/$listId'
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  appDashboardRoute: typeof appDashboardRouteWithChildren
  authLoginRoute: typeof authLoginRoute
  authRegisterRoute: typeof authRegisterRoute
  publicRoute: typeof publicRouteWithChildren
}

const rootRouteChildren: RootRouteChildren = {
  appDashboardRoute: appDashboardRouteWithChildren,
  authLoginRoute: authLoginRoute,
  authRegisterRoute: authRegisterRoute,
  publicRoute: publicRouteWithChildren,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/(app)/dashboard",
        "/(auth)/login",
        "/(auth)/register",
        "/(public)"
      ]
    },
    "/(app)/dashboard": {
      "filePath": "(app)/dashboard.tsx",
      "children": [
        "/(app)/dashboard/restaurants",
        "/(app)/dashboard/settings",
        "/(app)/dashboard/",
        "/(app)/dashboard/featured/",
        "/(app)/dashboard/lists/",
        "/(app)/dashboard/lists/detail/$listId"
      ]
    },
    "/(auth)/login": {
      "filePath": "(auth)/login.tsx"
    },
    "/(auth)/register": {
      "filePath": "(auth)/register.tsx"
    },
    "/(public)": {
      "filePath": "(public)",
      "children": [
        "/(public)/_public"
      ]
    },
    "/(public)/_public": {
      "filePath": "(public)/_public.tsx",
      "parent": "/(public)",
      "children": [
        "/(public)/_public/docs",
        "/(public)/_public/features",
        "/(public)/_public/",
        "/(public)/_public/lists/$token"
      ]
    },
    "/(app)/dashboard/restaurants": {
      "filePath": "(app)/dashboard/restaurants.tsx",
      "parent": "/(app)/dashboard"
    },
    "/(app)/dashboard/settings": {
      "filePath": "(app)/dashboard/settings.tsx",
      "parent": "/(app)/dashboard",
      "children": [
        "/(app)/dashboard/settings/change-password",
        "/(app)/dashboard/settings/user-profile",
        "/(app)/dashboard/settings/"
      ]
    },
    "/(public)/_public/docs": {
      "filePath": "(public)/_public/docs.tsx",
      "parent": "/(public)/_public"
    },
    "/(public)/_public/features": {
      "filePath": "(public)/_public/features.tsx",
      "parent": "/(public)/_public"
    },
    "/(app)/dashboard/": {
      "filePath": "(app)/dashboard/index.tsx",
      "parent": "/(app)/dashboard"
    },
    "/(public)/_public/": {
      "filePath": "(public)/_public/index.tsx",
      "parent": "/(public)/_public"
    },
    "/(app)/dashboard/settings/change-password": {
      "filePath": "(app)/dashboard/settings/change-password.tsx",
      "parent": "/(app)/dashboard/settings"
    },
    "/(app)/dashboard/settings/user-profile": {
      "filePath": "(app)/dashboard/settings/user-profile.tsx",
      "parent": "/(app)/dashboard/settings"
    },
    "/(public)/_public/lists/$token": {
      "filePath": "(public)/_public/lists/$token.tsx",
      "parent": "/(public)/_public"
    },
    "/(app)/dashboard/featured/": {
      "filePath": "(app)/dashboard/featured/index.tsx",
      "parent": "/(app)/dashboard"
    },
    "/(app)/dashboard/lists/": {
      "filePath": "(app)/dashboard/lists/index.tsx",
      "parent": "/(app)/dashboard"
    },
    "/(app)/dashboard/settings/": {
      "filePath": "(app)/dashboard/settings/index.tsx",
      "parent": "/(app)/dashboard/settings"
    },
    "/(app)/dashboard/lists/detail/$listId": {
      "filePath": "(app)/dashboard/lists/detail/$listId.tsx",
      "parent": "/(app)/dashboard"
    }
  }
}
ROUTE_MANIFEST_END */
